import { FC, useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router'

import { Divider, Flex, Timeline, Typography } from 'antd'

import dayjs from 'dayjs'

import { HTML } from '../components/markup/HTML'
import { Page } from '../components/page'
import { useUpdateQuery } from '../graphql'

const Updates: FC = () => {
  const { data, loading } = useUpdateQuery()
  useEffect(() => {}, [])
  const [version, setVersion] = useState(localStorage.getItem('version') ?? '')

  const updateVersion = useCallback((version: string) => {
    setVersion(version)
    localStorage.setItem('version', version)
    window.location.reload()
  }, [])

  useEffect(() => {
    if (!version && data?.update?.version) {
      localStorage.setItem('version', data?.update?.version)
    }
  }, [version, data?.update?.version])

  return (
    <Page
      title={data?.update?.title}
      loading={loading}
      extra={
        <Flex gap={8}>
          <Typography.Text strong>Версія</Typography.Text>
          <Typography.Text code>{data?.update?.version}</Typography.Text>
          {!!version && version !== data?.update?.version ? (
            <Link onClick={() => (data?.update?.version ? updateVersion(data?.update?.version) : null)} to={'#'}>
              Оновитись
            </Link>
          ) : null}
        </Flex>
      }
    >
      <Divider />
      <Timeline
        reverse
        mode={'left'}
        items={data?.update?.entries?.map((it) => ({
          color: it?.color === 'blue' ? '#1890ff' : it?.color,
          children: (
            <Flex vertical gap={8}>
              <Typography.Text strong>{dayjs(it?.date).format('YYYY.MM.DD')}</Typography.Text>
              <HTML>{it?.text}</HTML>
            </Flex>
          ),
        }))}
      />
    </Page>
  )
}

export { Updates as default }
